import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {SiteService} from '../../../../shared/services/site.service';
import { API_URLS } from 'src/environments/env-routes';
import { APIHelper } from 'src/shared/services/api-helper/api-helper.service';

@Component({
  selector: 'app-dialog-add-folder',
  templateUrl: './dialog-add-folder.component.html',
  styleUrls: ['./dialog-add-folder.component.scss']
})
export class DialogAddFolderComponent implements OnInit {
  public loading: boolean;
  public name: string;
  // public title: string;
  // public description: string;
  public actualId: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogAddFolderComponent>,
    private dialog: MatDialog,
    private siteService: SiteService,
    private api: APIHelper,
  ) {}

  ngOnInit() {
    this.loading = false;
    this.actualId = this.data.actualId;
  }
  public addFolder() {
    this.loading = true;
    const data = {
      alf_destination: 'workspace://SpacesStore/' + this.actualId,
      prop_cm_description: '',
      prop_cm_name: this.name,
      prop_cm_title: this.name
    };
    this.siteService
      .createFolder(data)
      .then(res => {
        const nodeRef=res.persistedObject;
        const folderId=nodeRef.substring(nodeRef.lastIndexOf('/') + 1);
        const queries = 'include=path,properties,allowableOperations,permissions';
        const data={
          permissions: { isInheritanceEnabled: false }
        }
        this.api
      .requestApi({
        action: API_URLS.nodes.nodes.replace(':nodeId', folderId),
        queryArgs: queries,
        method: 'PUT',
        datas: data
      }).then((res)=>{
        this.dialogRef.close(true);
      })
       
      })
      .finally(() => (this.loading = false));
  }
  onCancel() {
    this.dialogRef.close(false);
  }
}
